import { get } from 'lodash';

const statePath = 'GenericExportSetupState.setup.';

export const getExportFileTypes = state =>
  get(state, `${statePath}exportFileTypes`);
export const getGridData = state => get(state, `${statePath}gridData`, []);
export const getConstantValues = state =>
  get(state, `${statePath}constantValues`);
export const getExportFileType = state =>
  get(state, `${statePath}exportFileType`);
export const getExportFileTypeFuture = state =>
  get(state, `${statePath}exportFileTypeFuture`);
export const getLoading = state => get(state, `${statePath}loading`);
export const getSubmitting = state => get(state, `${statePath}submitting`);
export const getsaveSuccessful = state =>
  get(state, `${statePath}saveSuccessful`);
export const getExportMappingList = state =>
  get(state, `${statePath}exportMappingList`);
export const getError = state => get(state, `${statePath}error`);



// WEBPACK FOOTER //
// ./src/pages/genericexportsetup/state/selectors.js